import { grey } from "@mui/material/colors";
import { billingExplorerChartValuesPercentFormater } from "../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-chart/utils/helpers/billingExplorerChartValuesPercentFormater";
import { forecastSeriesName } from "../../../../../../common/billing-explorer/utils/addForecastedCostIntoBillingExplorerChartData";
import { money } from "@/utils/numeral/money";

export const generateCoverageChartTooltipMarkup = (
  title: string,
  seriesName: string,
  color: string,
  cost: number,
  percent: number,
  total?: number,
  totalPercent?: number,
) => {
  const moneyPostFix = !percent
    ? ""
    : `<span style="color: #888">(${billingExplorerChartValuesPercentFormater(percent)})</span>`;

  const showTotal = seriesName !== forecastSeriesName && total !== undefined;

  return `
    <div style="font-size: 13px; color: #666; margin-bottom: 8px">
      ${title}
    </div>

    <div style="display: flex; flex-direction: column; gap: 8px">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span
          style="
            display: flex;
            align-items: center;
            font-size: 11px;
            margin-right: 16px;
          "
        >
          <span
            style="font-weight: 500; font-size: 13px; width:${seriesName.length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; padding-left: 8px; border-left: 3px solid ${color}"
          >
            ${seriesName}
          </span>
        </span>
        
        <span style="font-weight: bold; font-size: 13px">
          ${money(cost)} ${moneyPostFix}
        </span>
      </div>
    </div>

    ${
      showTotal
        ? `
      <div style="
        margin-top: 10px;
        padding-top: 6px;
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        font-size: 13px;
        color: ${grey[600]};
      ">
        <span>Coverage</span><b>${money(total)} (${totalPercent?.toFixed(2) ?? 0}%)</b>
      </div>`
        : ""
    }
  `;
};
